import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserModuleTypeEnum, type UserPlanEnum } from '../../../core/user/user.model';
import { getPlanLabel } from '../../utils/response-module.utils';
import { ContactReason, getCsmMailtoHref } from '../../utils/response-mailto.utils';
import { ResponseModuleStateService } from '../../services/response-module-state.service';
import { AutoUnsubscribe } from '../../../common-explain/decorators/auto-unsubscribe';

type TrialBannerState = 'normal' | 'expiring' | 'expired';

@AutoUnsubscribe
@Component({
  selector: 'app-response-trial-banner',
  templateUrl: './response-trial-banner.component.html',
  styleUrls: ['./response-trial-banner.component.scss'],
})
export class ResponseTrialBannerComponent implements OnInit {
  visible = false;
  trialState: TrialBannerState = 'normal';
  daysRemaining = 0;
  plan: UserPlanEnum | null = null;
  accountType: UserModuleTypeEnum | null = null;

  private accountInfoSub: Subscription | null = null;

  constructor(private responseModuleStateService: ResponseModuleStateService) {}

  ngOnInit(): void {
    this.accountInfoSub = this.responseModuleStateService.state$.subscribe(state => {
      if (!state) {
        this.visible = false;
        return;
      }

      const { diffDays, accountType, plan } = state;

      if (diffDays === null || (accountType === UserModuleTypeEnum.PAID && diffDays > 0)) {
        this.visible = false;
        return;
      }

      this.accountType = accountType;
      this.plan = plan;
      this.daysRemaining = diffDays;
      this.trialState = diffDays <= 0 ? 'expired' : diffDays <= 7 ? 'expiring' : 'normal';
      this.visible = true;
    });
  }

  get mailtoHref(): string {
    if (this.trialState === 'expired') {
      return getCsmMailtoHref(this.accountType === UserModuleTypeEnum.PAID ? ContactReason.Expired : ContactReason.TrialEnded);
    }
    return getCsmMailtoHref(ContactReason.TrialEnding);
  }

  get planLabel(): string {
    return getPlanLabel(this.plan);
  }

  protected readonly UserModuleTypeEnum = UserModuleTypeEnum;
}
